import { z } from 'zod';

export const AnalyticsConfig = z
  .object({
    type: z.string(),
    project_id: z.string(),
    private_key_id: z.string(),
    private_key: z.string(),
    client_email: z.string(),
    client_id: z.string(),
    auth_uri: z.string(),
    token_uri: z.string(),
    auth_provider_x509_cert_url: z.string(),
    client_x509_cert_url: z.string(),
  })
  .strict();

export type GoogleAnalyticsConfig = z.infer<typeof AnalyticsConfig>;

export interface GoogleAnalyticsData {
  acquisitionMedium: this['medium'];
  acquisitionSource: this['source'];
  audience: AnalyticsAudience;
  medium: AnalyticsMedium;
  rows: Row[];
  source: AnalyticsSource;
  usersByAge: UsersByAge;
  usersByGender: UsersByGender;
}

export interface AnalyticsAudience {
  avgSessionDuration: number;
  bounceRate: number;
  newUsers: number;
  pageViews: number;
  pageViewsPerSession: number;
  returningUsers: number;
  sessions: number;
  sessionsPerUser: number;
  uniquePageViews: number;
  users: number;
}

export interface AnalyticsMedium {
  adwords: number;
  'not provided': number;
  organic: number;
  referral: number;
  email?: number;
}

export interface Row {
  avgTimeOnPage: number;
  bounceRate: number;
  entrances: number;
  exitRate: number;
  name: string;
  pageViews: number;
  uniquePageviews: number;
}

export interface AnalyticsSource {
  [source: string]: number;
}

export interface UsersByAge {
  '18-24': number;
  '25-34': number;
  '35-44': number;
  '45-54': number;
  '55-64': number;
  '65+': number;
}

export interface UsersByGender {
  female: number;
  male: number;
  other?: number;
}

export const mockAnalyticsAudience: AnalyticsAudience = {
  avgSessionDuration: 82.9082005899705,
  bounceRate: 51.06784660766962,
  newUsers: 6268,
  pageViews: 17392,
  pageViewsPerSession: 2.0521533923303834,
  returningUsers: 117,
  sessions: 8475,
  sessionsPerUser: 1.327329678935004,
  uniquePageViews: 14130,
  users: 6385,
};

export const mockAnalyticsMedium: AnalyticsMedium = {
  adwords: 1415,
  'not provided': 1643,
  organic: 3621,
  referral: 1773,
  email: 23,
};

export const mockRow: Row = {
  avgTimeOnPage: 67.26555078036644,
  bounceRate: 46.224619289340104,
  entrances: 6304,
  exitRate: 48.159005628517825,
  name: '/',
  pageViews: 8528,
  uniquePageviews: 6454,
};

export const mockAnalyticsSource: AnalyticsSource = {
  '(direct) / (none)': 1643,
  'google / cpc': 1415,
  'google / organic': 3453,
  'google.com / referral': 4,
  'wordfly / email': 23,
  'yahoo / organic': 48,
};

export const mockUsersByAge: UsersByAge = {
  '18-24': 241,
  '25-34': 444,
  '35-44': 286,
  '45-54': 215,
  '55-64': 207,
  '65+': 151,
};

export const mockUsersByGender: UsersByGender = {
  female: 937,
  male: 654,
};

export const mockGoogleAnalytics: GoogleAnalyticsData = {
  acquisitionMedium: mockAnalyticsMedium,
  acquisitionSource: mockAnalyticsSource,
  audience: mockAnalyticsAudience,
  medium: mockAnalyticsMedium,
  rows: [mockRow],
  source: mockAnalyticsSource,
  usersByAge: mockUsersByAge,
  usersByGender: mockUsersByGender,
};
